/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { css, cx } from "@panda/css";
import { Box, BoxProps } from "@panda/jsx";

const tableRowStyles = css({
	width: "100%",
	display: "grid",
	gridTemplateColumns: "subgrid",
	gridColumn: "1 / -1",
	backgroundColor: "eds.palette.transparent.light.005",
	backdropFilter: "var(--effect-material-blur, blur(50px))",
});

/**
 * Expects to wrap one ore more TableCells.
 */

export interface CosmosTableRowProps extends BoxProps {
	className?: string;
	children: React.ReactNode;
}

export const CosmosTableRow = ({ className, children, ...props }: CosmosTableRowProps): React.JSX.Element => {
	return (
		<Box {...props} className={cx("cosmos-table__row", tableRowStyles, className)}>
			{children}
		</Box>
	);
};

CosmosTableRow.displayName = "CosmosTable.Row";
